module.exports = __webpack_public_path__ + "media/metronic/_theme/media/project-logos/3-57ef86349fca0456b7bc394789cb94c3.png";